/**
 * 文案位置
 */
export enum AdvertisementPositionType {

    /** 左上 */
    LEFT_TOP = '1',

    /** 上 */
    TOP = '1',

    /** 右上 */
    RIGHT_TOP = '3',

    /** 左中 */
    LEFT_CENTER ='4',

    /** 中 */
    CENTER ='5',

    /** 右中 */
    RIGHT_CENTER ='6',

    /** 左下 */
    LEFT_BOTTOM='7',

    /** 下 */
    BOTTOM='8',

    /** 右下 */
    RIGHT_BOTTOM='9',

    /** 未明 */
    UNKNOWN='-9'
}
